// extracted by mini-css-extract-plugin
export default {"wrapper":"InputText_wrapper__qB581","input":"InputText_input__dTh9Q","error":"InputText_error__ctNci","error-message":"InputText_error-message__lGX66"};